// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brand-name[data-v-76032fd1]{font-style:italic}.text-superscript[data-v-76032fd1]{vertical-align:super;font-size:.8em}.discount[data-v-76032fd1]{top:-5px;right:0;position:absolute;background:#0cecdc;color:#000;z-index:1}.option[data-v-76032fd1]{width:80vw;border:1px solid #000!important;margin-bottom:1px}@media only screen and (min-width:960px){.discount[data-v-76032fd1]{top:-30px;right:auto}.option[data-v-76032fd1]{width:150px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
